<template>
	<LayoutLoading text="Cargando empresa" v-if="!loaded" />
	<div class="d-flex flex-column h-100" style="padding-top: 75px;" v-else>
		<LayoutHeaderMain :fixed="true" />
		<main class="flex-fill d-flex flex-column">
			<router-view v-slot="{ Component }">
				<transition name="route" mode="out-in">
					<component :is="Component" />
				</transition>
			</router-view>
		</main>
		<CustomerModalOption />
		<CustomerModalContact />
		<CustomerModalContacted />
		<CustomerModalProposed />
		<CustomerModalStatus />
		<CommonButtonScrollToBottom />
	</div>
</template>

<script>
	import { computed, onMounted } from 'vue';
	import store from '@/store';
	import router from '@/router';
	import composableForm from '@/composables/form';
	import ModelRepository from '@/repositories/modules/Company/Current';

	export default {
		props: {
			company_id: String
		},
		setup(props) {
			const { catchError } = composableForm();
			const company = computed(() => store.getters['company/info']);
			const loaded = computed(() => (props.company_id == company.value?.id));

			onMounted(async () => {
				if(!loaded.value) {
					await store.dispatch('company/empty');
					await ModelRepository.show(props.company_id).then((response) => {
						store.dispatch('company/setInfo', response.data);
					}).catch((e) => {
						catchError(e, true);
						return router.push({ name: 'home' });
					});
				}
			});

			return { company, loaded };
		}
	}
</script>